import React from 'react';
import styles from './AbstractProductDetailsForm.module.scss';
import {Grid} from '@material-ui/core';
import TermsOfServiceCheckbox from 'gui/components/termsOfServiceCheckBox';
import AbstractDetailsForm
  from 'gui/components/editors/commons/editor/components/abstractDetailsForm/AbstractDetailsForm';


interface IAbstractProductDetailsFormProps {
  onSubmit?: (formValues: any) => Promise<any>;

  yupSchemaObject?: any;
  initialValues?: any;
  setSubmitRef?: any;
  commonFormComponents?: any;
  formComponents?: any;

  additionalCheckboxComponents?: any;

}


const AbstractProductDetailsForm = (props: IAbstractProductDetailsFormProps) => (
  <AbstractDetailsForm
    {...props}
    className={styles.abstractProduct}
    underFormComponents={form => <>
      <Grid item xs={12} className={styles.termsContainer}>
        <div className={styles.checkBoxContainer}>
          {typeof props.additionalCheckboxComponents === 'function' ? props.additionalCheckboxComponents(form) : null}
          <TermsOfServiceCheckbox {...form}/>
        </div>
      </Grid>
    </>}
  />
);

AbstractProductDetailsForm.defaultProps = {};

export default React.memo(AbstractProductDetailsForm);
